import { render, staticRenderFns } from "./GRoundedArrowButton.vue?vue&type=template&id=8e58d9b6&scoped=true&"
import script from "./GRoundedArrowButton.vue?vue&type=script&lang=ts&"
export * from "./GRoundedArrowButton.vue?vue&type=script&lang=ts&"
import style0 from "./GRoundedArrowButton.vue?vue&type=style&index=0&id=8e58d9b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e58d9b6",
  null
  
)

export default component.exports